import { render, staticRenderFns } from "./levelShow.vue?vue&type=template&id=9ab683d2&scoped=true&"
import script from "./levelShow.vue?vue&type=script&lang=ts&"
export * from "./levelShow.vue?vue&type=script&lang=ts&"
import style0 from "./levelShow.vue?vue&type=style&index=0&id=9ab683d2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ab683d2",
  null
  
)

export default component.exports